import React from "react";
import PageHeader from "../../components/pageHeader";
import {Layout, Button, Col, Row, Form, Input, Table, Icon} from "antd";
import {DeviceModel} from "../../models/device-model";
import {connect} from "react-redux";
import actions from "../../redux/device-model/actions";
import manufacturerListActions from "../../redux/manufacturer-list/actions";
import CheckError from "../../components/checkError";
import DeleteModal from "../../components/deleteModal";
import {Container} from "../Container";
import EditModal from "./EditModal";
import ImportProgress from "../../components/importProgress";

const {Content} = Layout;
const {
    getDeviceModels,
    deleteDeviceModel,
    createDeviceModel,
    updateDeviceModel,
    importDeviceModels,
    getDeviceModelsPdf,
    getDeviceModelsCsv
} = actions;
const {getManufacturerList} = manufacturerListActions;

export class DeviceModelsContainer extends Container {

    state = {
        editModalVisible: false,
        editModalTitle: '',
        deleteModalVisible: false,
        deviceModel: {},
        fullText: ''
    };

    resource = 'deviceModels';
    model = new DeviceModel();
    getResource = (params) => {
        this.props.getDeviceModels(params);
    };

    componentDidMount() {
        this.props.getManufacturerList(this.props.manufacturerList);
        if (this.props.deviceModels.fullText !== this.state.fullText) {
            this.setState({fullText: this.props.deviceModels.fullText});
        }
        this.getResource(this.props[this.resource]);
    };

    /**
     * Drukuje dane
     */
    print = () => {
        this.props.getDeviceModelsPdf({});
    }

    /**
     * Pobiera dane
     */
    download = () => {
        this.props.getDeviceModelsCsv({});
    }

    /**
     * @description Otwiera okno usuwania danych
     */
    showDeleteModal = (record) => {
        this.setState({
            deviceModel: record,
            deleteModalVisible: true
        });
    }

    /**
     * @description Usuwa dane
     */
    handleDeleteOk = () => {
        this.props.deleteDeviceModel(this.state.deviceModel.id);
        this.setState({
            deviceModel: {},
            deleteModalVisible: false
        });
    }

    /**
     * @description Anuluje usuwanie danych
     */
    handleDeleteCancel = () => {
        this.setState({
            deleteModalVisible: false
        });
    }

    /**
     * Otwiera okno dodawania danych
     * @param record
     */
    showAddModal = (record) => {
        this.setState({
            editModalVisible: true,
            editModalTitle: 'Dodaj model',
            deviceModel: new DeviceModel()
        });
    }

    /**
     * Otwiera okno edycji danych
     * @param record
     */
    showEditModal = (record) => {
        this.setState({
            editModalVisible: true,
            editModalTitle: 'Edytuj model ' + record.name,
            deviceModel: record
        });
    }

    /**
     * Zapisuje dane
     */
    handleSave = () => {
        const form = this.editFormRef.props.form;
        form.validateFields((err, values) => {
            //przerwanie procesu w przypadku wystąpienia błędów na formularzu
            if (err) {
                return;
            }
            //console.log(values);
            //wysyłka danych do serwera
            const m = new DeviceModel();
            if (this.state.deviceModel.id) {
                this.props.updateDeviceModel(this.state.deviceModel.id, m.getData(values));
            } else {
                this.props.createDeviceModel(m.getData(values));
            }

            //console.log('Received values of form: ', m.getData(values));

            //wyczyszczenie formularza
            form.resetFields();

            //zamknięcie okna edycji
            this.setState({
                editModalVisible: false
            });
        });
    }

    /**
     * Anuluje edycję danych
     */
    handleCancel = () => {
        this.setState({
            editModalVisible: false
        });
    }

    /**
     * Uruchomienie filtra i zamknięcie okienka
     * (właściwe fitrowanie obługiwane jest przez metodę handleTableChange)
     * @param selectedKeys
     * @param confirm
     */
    handleSearch = (selectedKeys, confirm) => {
        confirm();
    }

    /**
     * Wyczyszczenie filtra i zamknięcie okienka
     * (właściwe czyszczenie fitra obługiwane jest przez metodę handleTableChange)
     * @param clearFilters
     */
    handleReset = (clearFilters) => {
        clearFilters();
    }

    handleResetFullText = () => {
        this.setState({fullText: ''}, () => {
            this.filterFullText('');
        });
    };

    handleKeyDownFullText = (e) => {
        if (e.key === 'Enter') {
            this.filterFullText(this.state.fullText);
        }
    }

    /**
     * Zwraca referencję do formularza edycji
     * @param formRef
     */
    saveEditFormRef = (formRef) => {
        this.editFormRef = formRef;
    }

    importDeviceModels = () => {
        this.props.importDeviceModels();
    }

    render() {
        const columns = [{
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            sorter: true,
            defaultSortOrder: this.props[this.resource].sort.id || null,
            filteredValue: this.props[this.resource].filters.id || null,
            ...this.getColumnSearchProps('id'),
        }, {
            title: 'Producent',
            dataIndex: 'manufacturer_name',
            key: 'manufacturer_name',
            sorter: true,
            defaultSortOrder: this.props[this.resource].sort.manufacturer_name || null,
            filteredValue: this.props[this.resource].filters.manufacturer_name || null,
            ...this.getColumnSearchProps('manufacturer_name'),
        }, {
            title: 'Nazwa',
            dataIndex: 'name',
            key: 'name',
            sorter: true,
            defaultSortOrder: this.props[this.resource].sort.name || null,
            filteredValue: this.props[this.resource].filters.name || null,
            ...this.getColumnSearchProps('name'),
        }, {
            title: 'Nazwa SEO',
            dataIndex: 'seo_name',
            key: 'seo_name',
            sorter: false
        }, {
            title: 'Liczba produktów',
            dataIndex: 'product_count',
            key: 'product_count',
            sorter: false
        }, {
            title: 'Akcje',
            key: 'action',
            render: (text, record) => (
                <Button.Group>
                    <Button type="primary" icon="edit" title="Edytuj" onClick={(e) => {
                        this.showEditModal(record);
                        e.stopPropagation();
                    }}></Button>
                    <Button type="primary" icon="delete" title="Usuń" onClick={(e) => {
                        this.showDeleteModal(record);
                        e.stopPropagation();
                    }}></Button>
                </Button.Group>
            ),
        }
        ];
        return <div>
            <Layout style={{padding: '0 24px 24px'}}>
                <PageHeader>Modele urządzeń</PageHeader>
                <Content style={{
                    background: '#fff',
                    padding: 24,
                    margin: 0,
                }}>
                    <Row>
                        <Col span={4}>
                            <Button.Group>
                                <Button icon="printer" onClick={this.print} title="Drukuj"></Button>
                                <Button icon="download" onClick={this.download}
                                        title="Pobierz"></Button>
                                <Button icon="reload" onClick={this.refresh}
                                        title="Odśwież"></Button>
                            </Button.Group>
                        </Col>
                        <Col span={20} style={{textAlign: 'right'}}>
                            <Form layout="inline">
                                <Form.Item>
                                    <Input
                                        placeholder="Szukaj"
                                        value={this.state.fullText}
                                        onChange={(e) => this.setState({fullText: e.target.value})}
                                        onKeyDown={this.handleKeyDownFullText}
                                        suffix={<Icon type="close"
                                                      onClick={this.handleResetFullText}/>}
                                        addonAfter={<Icon type="search"
                                                          onClick={(e) => this.filterFullText(this.state.fullText)}/>}
                                    />
                                </Form.Item>

                                <Form.Item>
                                    <Button type="default" icon="plus" onClick={this.showAddModal}>Dodaj</Button>
                                </Form.Item>

                                <Form.Item>
                                    <Button type="primary" icon="import" onClick={this.importDeviceModels}
                                            title="Importuj">Importuj</Button>
                                </Form.Item>
                            </Form>
                        </Col>
                    </Row>
                </Content>

                <Content style={{
                    background: '#fff',
                    padding: 24,
                    margin: 0,
                }}>
                    <ImportProgress data={this.props.deviceModels}/>
                    <CheckError error={this.props.deviceModels.error} history={this.props.history}/>
                    <Table
                        pagination={{
                            ...this.props.deviceModels.pagination,
                            pageSizeOptions: ['5', '10', '20'], // ręczna opcja liczby wyświetlanych rekordow na stronie
                            showSizeChanger: true,
                            showQuickJumper: true,
                            showTotal: this.showTotalItemsDialog,
                        }}
                        columns={columns}
                        dataSource={this.props.deviceModels.items}
                        loading={this.props.deviceModels.loading}
                        rowKey="id"
                        onChange={this.handleTableChange}
                        onRow={(record) => {
                            return {
                                onClick: () => {
                                    //history.push(this.props.url + '/' + record.id)
                                },
                                onMouseEnter: () => {
                                },  // mouse enter row
                            };
                        }
                        }
                    />

                    <EditModal
                        wrappedComponentRef={this.saveEditFormRef}
                        title={this.state.editModalTitle}
                        visible={this.state.editModalVisible}
                        onSave={this.handleSave}
                        onCancel={this.handleCancel}
                        data={this.state.deviceModel}
                        manufacturers={this.props.manufacturerList.items}
                    >
                    </EditModal>

                    <DeleteModal
                        title="Usuwanie modelu"
                        content={<div><p>Czy na pewno usunąć dane modelu: <i>{this.state.deviceModel.name}</i>?</p>
                        </div>}
                        visible={this.state.deleteModalVisible}
                        onDelete={this.handleDeleteOk}
                        onCancel={this.handleDeleteCancel}
                    >
                    </DeleteModal>
                </Content>
            </Layout>
        </div>;
    }
}

const mapStateToProps = (state) => ({
    deviceModels: state.DeviceModels,
    manufacturerList: state.ManufacturerList
});

export default connect(mapStateToProps, {
    getDeviceModels,
    deleteDeviceModel,
    createDeviceModel,
    updateDeviceModel,
    importDeviceModels,
    getManufacturerList,
    getDeviceModelsPdf,
    getDeviceModelsCsv
})(DeviceModelsContainer);
